// This should ideally come from codegen.

import {
  type RetailerCollectionSurface,
  type GetRetailerCollectionQueryResult,
} from 'domains/retailer-collections/api'

export enum RetailerCollectionOwner {
  Retailer = 'retailer',
  Instacart = 'instacart',
}

// Use this type when using as a value
export {
  RetailerCollectionSurface,
  RetailerCollectionContentType,
  RetailerCollectionStatus,
} from 'domains/retailer-collections/api'

// This is a type containing only the supported Surface types, in other words, excluding unspecified types
export type SupportedSurface = Exclude<
  RetailerCollectionSurface,
  RetailerCollectionSurface.EnumTypeSurfaceUnspecified
>

export interface SurfaceDetails {
  id: SupportedSurface
  slug: string
  label: string
  logo: string
}

export type RetailerCollection =
  GetRetailerCollectionQueryResult['data']['retailerCollectionsServiceGetRetailerCollection']['retailerCollection']

export type InstacartCollection = {
  label: string
  key: string
}

export type RetailerCollectionComputed = {
  owner: RetailerCollectionOwner
}
export type RefetchFn = () => void
